export default __webpack_public_path__ + "static/testimonial-photo-ed3f4cb9d4b48918d6686ece6db1e49f.jpeg";